import TitleWithIcon from "components/ui/TitleWithIcon/TitleWithIcon";
import { ReactComponent as IconSearch } from "assets/images/icons/search.svg";
import { ReactComponent as IconCalendar } from "assets/images/icons/calendar.svg";
import { ReactComponent as IconPin } from "assets/images/icons/pin.svg";
import "pages/Homepage/Usps/Usps.scss";
import { Link } from "react-router-dom";

function Usps() {
  return (
    <div className={ 'grid' }>
      <div className={ 'usps' }>
        <div className={ 'usp' }>
          <TitleWithIcon title={ 'Leden zoeken' } headingSize={ 'small' }>
            <IconSearch/>
          </TitleWithIcon>
          <div className={ 'usp__text' }>
            Kom in contact met andere leden.
          </div>
          <Link to={'leden'} className={'link-overlay'} aria-label={ 'Navigeer naar leden zoeken' }/>
        </div>

        <div className={ 'usp' }>
          <TitleWithIcon title={ 'Prikbord' } headingSize={ 'small' }>
            <IconPin/>
          </TitleWithIcon>
          <div className={ 'usp__text' }>
            Plaats een oproep of nodig anderen uit om samen iets te ondernemen.
          </div>
          <Link to={'prikbord'} className={'link-overlay'} aria-label={ 'Navigeer naar prikbord' }/>
        </div>

        <div className={ 'usp' }>
          <TitleWithIcon title={ 'Activiteiten' } headingSize={ 'small' }>
            <IconCalendar/>
          </TitleWithIcon>
          <div className={ 'usp__text' }>
            Neem deel aan activiteiten in het land.
          </div>
          <Link to={'activiteiten'} className={'link-overlay'} aria-label={ 'Navigeer naar activiteiten' }/>
        </div>
      </div>
    </div>
  );
}

export default Usps;
